<app-product-property-option-list-editor
	[selectedOptions$]="selectedOptions$"
	[valueOptions]="valueOptions"
	(doneEditing)="doneEditingHandler()"
>
</app-product-property-option-list-editor>
